/*
Maximum number of sell operations allowed in a week for a ranked portfolio
**/
export const RANKED_PORTFOLIO_WEEKLY_SELL_OPERATION_LIMIT = 5;

/**
Order types
**/
export enum PortfolioOrderTypes {
  // Order executed on next price update
  MARKET_PRICE = 'MARKET_PRICE',
  // Order executed at a specific price
  LIMIT_PRICE = 'LIMIT_PRICE',
  // Gives freedom of date and price, creates operation right away
  PAST_OPERATION = 'PAST_OPERATION',
}

/**
Order States
**/
export enum PortfolioOrderStates {
  // Waiting for execution
  PENDING = 'PENDING',
  // Executed
  COMPLETED = 'COMPLETED',
  // Cancelled by user
  MANUALLY_CANCELLED = 'MANUALLY_CANCELLED',
  // Cancelled by system
  CANCELLED = 'CANCELLED',
  // Optional intermediate state used by api to indicate the order is ready for execution.
  // From the pwa perspective, should be equivalent to PENDING.
  READY = 'READY',
}

/**
Operation types
**/
export const OPERATION_TYPES = {
  BUY: 'Buy',
  SELL: 'Sell',
} as const;

export type OperationType =
  (typeof OPERATION_TYPES)[keyof typeof OPERATION_TYPES];

export function getOperationTypeLabelKey(
  operationType: string | undefined
): string {
  switch (operationType) {
    case OPERATION_TYPES.BUY:
      return 'portfolio_table_buy';
    case OPERATION_TYPES.SELL:
      return 'portfolio_table_sell';
    default:
      return '';
  }
}

/**
Portfolio transaction types
 */
export enum PortfolioTransactionTypes {
  ORDER = 'ORDER',
  TRANSACTION = 'TRANSACTION',
}
